import { flightTypesList, ICustomAutoCompleteSearch } from './types';

export function getUTCTimeStamp(date: Date | undefined): number {
  if (typeof date === 'undefined') {
    return Date.now();
  }
  const utcTimeStamp = new Date(date);
  return utcTimeStamp.getTime();
}

export function getReversedDate(date: Date | undefined): string {
  if (!date) {
    return '';
  }
  const dateToSplit = new Date(date);
  const utcMonth = dateToSplit.getUTCMonth() + 1;
  const utcMonthString = utcMonth < 10 ? `0${utcMonth}` : utcMonth;
  return `${dateToSplit.getUTCFullYear()}-${utcMonthString}-${("00" + dateToSplit.getUTCDate()).slice(-2)}`;
}

export function getTripType(tripType: string | undefined): number {
  switch (tripType) {
    case flightTypesList.ROUND_TRIP:
      return 1;
    case flightTypesList.ONE_WAY:
      return 2;
    case flightTypesList.MULTI_CITY:
      return 3;
    default:
      return 1;
  }
}

export function getOriginOrDestination(
  value: ICustomAutoCompleteSearch | undefined
): string {
  if (typeof value === 'undefined') {
    return '';
  }
  const { city, code }: ICustomAutoCompleteSearch = value;
  if (code.length) {
    return `${city} (${code})`;
  }
  return city;
}
